import { PageViewEventLogger } from '@repo/tracking-service';
import { AuthGuard } from '@repo/user-session';
import { ReactElement } from 'react';

import { ReasonContent } from '@/components/auth/withdraw/ReasonContent';

function WithdrawReasonPage() {
  return (
    <>
      <ReasonContent />
      <PageViewEventLogger pageName={'feedback-delete'} eventName={'feedback-delete_reason'} />
    </>
  );
}

WithdrawReasonPage.getLayout = (page: ReactElement) => <AuthGuard>{page}</AuthGuard>;

export default WithdrawReasonPage;
